module.exports = __webpack_public_path__ + "media/images/img/tag_company/medley_tag-f50a0f518e393899d80c641b8a83e57f.png";